export enum ProductTileKey {
    TRAVEL = 'TRAVEL',
    CDW = 'CDW',
    MOTO = 'MOTO',
    HOME = 'HOME',
}
